import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const FormSkeletonLoader = () => {
  return (
    <div className="w-full px-4 sm:px-6 lg:px-8">
      {/* Page Heading Skeletons */}
      <div className="mb-8 space-y-2">
        <Skeleton height={28} width={250} />
        <Skeleton height={20} width={400} />
      </div>

      {/* Form Fields */}
      <div className="space-y-12">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="flex items-center gap-x-8">
            <div className="w-1/4">
              <Skeleton height={20} width={120} />
            </div>
            <div className="w-3/4">
              <Skeleton height={40} />
            </div>
          </div>
        ))}
        <div className="flex items-center justify-end gap-x-6 pt-4">
          <Skeleton height={40} width={90} />
        </div>
      </div>
    </div>
  );
};

export default FormSkeletonLoader;
